var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"wrapper-title d-flex align-items-center"},[_c('div',{staticClass:"page-title font-weight-bold"},[_c('div',[_vm._v(" "+_vm._s(_vm.titles.join(" / "))+" ")]),(!_vm.hideCount)?_c('div',{staticClass:"ml-1"},[_vm._v("("+_vm._s(_vm.dataCount)+")")]):_vm._e()])])])
}
var staticRenderFns = []

export { render, staticRenderFns }